import { Layout } from "@/components/layout/Layout";
import { TemplateBrowser } from "@/components/template/TemplateBrowser";
import { NewMenu } from "@/components/template/NewMenu";

export function TemplatesPage() {
  return (
    <Layout>
      <div className="mx-auto max-w-6xl p-6">
        <div className="mb-6 flex items-center justify-between">
          <h1 className="text-2xl font-semibold text-ink">
            Templates
          </h1>
          <NewMenu />
        </div>
        <TemplateBrowser />
      </div>
    </Layout>
  );
}
